<template>
<div class="pos-f tg-newbie" style>
	<a :href="data.clickUrl" data-scp="newbie.00" data-reload="true">
		<img :src="data.imageUrl" :width="Math.ceil(data.width/3)" :height="Math.ceil(data.height/3)" alt=""/>
	</a>
</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object
			, default: {}
		}
	}
};
</script>

<style lang="scss">
	/*.tg-newbie{*/
		/*min-height: 76px;*/
		/*width: 102px;*/
	/*}*/
</style>